<div class="container prel" *ngIf="cardCounts">
  <div class="">
    <div class="row justify-content-between mt20 align-items-center">
      <h3 class="titlestyle1 text-uppercase" translate>

      </h3>
      <ng-multiselect-dropdown style="width: 25%;" [settings]="dropdownSettings" [data]="dealerList"
        placeholder="{{ 'lblSearchDealer'| translate}}" [(ngModel)]="selectedDealers"
        (onDeSelect)="onChangeDealer($event)" (onSelect)="onChangeDealer($event)" (onSelectAll)="onChangeDealer($event)" (onDeSelectAll)="onChangeDealer($event)">
      </ng-multiselect-dropdown>
    </div>
    <div class="das-grid mt15">





      <fieldset>
        <legend translate>lblAppointment</legend>
        <div class="dashbox  border-0 align-items-center clrYellow">
          <div class="row align-items-center ">
            <div class="col-md-12" (click)="ClickOnTomorrow('today')">
              <h3 translate class="mb10">
                lblToday
              </h3>
            </div>
            <div class="col-md-6" (click)="ClickOnTomorrow('today')">
              <div class="number">{{cardCounts.todaysAppointmentCount}}</div>
            </div>
            <div class="col-md-6 text-right">
              <div class="d-flex align-items-center justify-content-end" (click)="ClickOnTomorrow('tomorrow')">
                <span class="sub-tomorrow-txt" translate>lblTomorrow</span><span
                  class="sub-tomorrow-txt mx-2">-</span><span
                  class="sub-tomorrow-count">{{cardCounts.tomorrowsAppointmentCount}}</span>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset>
        <legend translate>lblCheckedIn</legend>
        <div class="dashbox border-0 align-items-center clrDarkSea" (click)="GetCheckInData('today')">
          <div class="row align-items-center">
            <div class="col-md-12">
              <h3 translate class="mb10">
                lblToday
              </h3>
            </div>
            <div class="col-md-6" (click)="GetCheckInData('today')">
              <div class="number">{{cardCounts.todaysCheckedInCount}}</div>
            </div>
            <div class="col-md-6 text-right">
              <div class="d-flex align-items-center justify-content-end" (click)="GetCheckInData('tomorrow')">
                <span class="sub-tomorrow-txt" translate>lblTomorrow</span><span
                  class="sub-tomorrow-txt mx-2">-</span><span
                  class="sub-tomorrow-count">{{cardCounts.tomorrowsCheckedInAppointmentCount}}</span>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset>
        <legend translate>lblNotCheckedIn</legend>
        <div class="dashbox border-0 align-items-center clrBlue" (click)="GetNotCheckInData('today')">
          <div class="row align-items-center">
            <div class="col-md-12">
              <h3 translate class="mb10">
                lblToday
              </h3>
            </div>
            <div class="col-md-6" (click)="GetNotCheckInData('today')">
              <div class="number">{{cardCounts.todaysNotCheckedInCount}}</div>
            </div>
            <div class="col-md-6 text-right">
              <div class="d-flex align-items-center justify-content-end" (click)="GetNotCheckInData('tomorrow')">
                <span class="sub-tomorrow-txt" translate>lblTomorrow</span><span
                  class="sub-tomorrow-txt mx-2">-</span><span
                  class="sub-tomorrow-count">{{cardCounts.tomorrowsNotCheckedInAppointmentCount}}</span>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset>
        <legend translate>lblCancelled</legend>
        <div class="dashbox border-0 align-items-center clrRed" (click)="GetCancelledAppointmentData('today')">
          <div class="row align-items-center ">
            <div class="c12 ">
              <h3 translate class="mb10">
                lblToday
              </h3>
            </div>
            <div class="col-md-6" (click)="GetCancelledAppointmentData('today')">
              <div class="number">{{cardCounts.todaysCancelledCount}}</div>
            </div>
            <div class="col-md-6 text-right">
              <div class="d-flex align-items-center justify-content-end"
                (click)="GetCancelledAppointmentData('tomorrow')">
                <span class="sub-tomorrow-txt" translate>lblTomorrow</span><span
                  class="sub-tomorrow-txt mx-2">-</span><span
                  class="sub-tomorrow-count">{{cardCounts.tomorrowsCancelledAppointmentCount}}</span>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset *ngIf="isShowWidgetAppointmentRequests">
        <legend translate>lblWidgetAppointmentRequests</legend>
        <div class="dashbox border-0 align-items-center clrGreen" (click)="WidgetAppointment('All')">
          <div class="row align-items-center ">
            <div class="col-12">
              <h3 translate class="mb10">
                lblAppointment
              </h3>
            </div>
            <div class="col" (click)="WidgetAppointment('All')">
              <div class="number">{{cardCounts.widgetAppointmentCount}}</div>
            </div>
            <div class="col flex-grow-3 text-right pl-0">
              <div class="d-flex align-items-center justify-content-end" (click)="WidgetAppointment('Pending')">
                <span class="sub-tomorrow-txt" translate="">lblPendingtoApprove</span><span
                  class="sub-tomorrow-txt mx-2">-</span><span
                  class="sub-tomorrow-count">{{cardCounts.widgetPendingAppointmentCount}}</span>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset *ngIf="WorkshopCapacityFeature">
        <legend translate>lblWorkshopCapacity</legend>
        <div class="dashbox border-0 align-items-center clrRed">
          <div class="row align-items-center ">
            <div class="c12 ">
              <h3 translate class="mb10">
                lblToday
              </h3>
            </div>
            <div class="col-md-6">
              <div class="number">{{cardCounts.todaysCancelledCount}}</div>
            </div>
            <div class="col-md-6 text-right">
              <div class="d-flex align-items-center justify-content-end">
                <span class="sub-tomorrow-txt" translate>lblTomorrow</span><span
                  class="sub-tomorrow-txt mx-2">-</span><span
                  class="sub-tomorrow-count">{{cardCounts.tomorrowsCancelledAppointmentCount}}</span>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
    <div class="das-grid three-two mt15" >
      <fieldset>
        <legend translate>lblBrandWiseAppointment</legend>
        <div class="dashbox  border-0 align-items-center clrYellow">
          <div class="row align-items-center" >
            <div class="d-flex justify-content-end align-items-center" style="margin-left: auto !important;">
              <div>
                <button *ngFor="let button of barChartButtons; let i = index"
                  [ngClass]="button.isClicked == true ? 'sorting selected' : 'sorting'" (click)="randomize(button.text,i)">
                  {{ button.text }}
                </button>
              </div>
            </div>
            <div class="card-body">
              <div>
                <div style="display: block">
                  <canvas baseChart [datasets]="barChartData" [labels]="mbarChartLabels" [options]="barChartOptions"
                    [colors]="barChartColors" [legend]="barChartLegend" [chartType]="barChartType" style="height: 300px;"></canvas>
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
       <fieldset  *ngIf="isShowNumberOfDealerWithNoAppointment">
        <legend translate>lblDealersAppointmentServices</legend>
        <div class="dashbox  border-0 align-items-center clrYellow">
          <div class="row">
            <div class="col-lg-7">
                <input bsDaterangepicker name="BookedDate" [bsConfig]="dateDealerWithNoAppointmentRangePickerOptions" class="form-control" [(ngModel)]="selectedDealerWithNoAppointmentDate" 
                (ngModelChange)="onDateDealerWithNoAppointmentRangeChanged($event)" />
            </div>
            <div class="col-lg-5">
                <button type="button" (click)="getDealerWithNoAppointments()" class="btn btn-primary">
                  <em class="fa fa-search"></em>
                </button>
            </div>
          </div>
          <div class="row d-flex justify-content-center" style="margin-top: 50px;" >
            <div class="dealer-appointment-card col-lg-9 card mb-4">
                <div class="card-box">
                    <div class="inner">
                        <h3>{{dealersCountWithAppointments}}</h3>
                        <p translate>lblNumberofDealerWithAppointments</p>
                    </div>                        
                    <p class="card-box-footer" style="cursor: pointer;" (click)="exportDealerWithAppointmentAsXLSX()">
                    {{'ExportToExcel'| translate}} 
                      <i class="fa fa-file-export"></i></p>
                </div>
            </div>

            <div class="dealer-appointment-card col-lg-9 card">
                <div class="card-box">
                    <div class="inner">
                      <h3>{{dealersCountWithNoAppointments}}</h3>
                        <p translate>lblNumberofDealerWithNoAppointments</p>
                    </div>
                    <p class="card-box-footer" style="cursor: pointer;" (click)="exportDealerWithNoAppointmentAsXLSX()">
                    {{'ExportToExcel'| translate}} 
                      <i class="fa fa-file-export"></i></p>
                </div>
            </div>                
          </div>
        </div>
      </fieldset>
      <!-- <fieldset>
        <legend translate>lblDealerWithAppointment</legend>
        <div class="dashbox  border-0 align-items-center clrYellow">
          <div class="row align-items-center" >
            <div class="d-flex justify-content-end align-items-center" style="margin-left: auto !important;">
              <div class="px-20px">
                <button *ngFor="let button of barChartButtons; let i = index"
                  [ngClass]="button.isClicked == true ? 'sorting selected' : 'sorting'" (click)="randomize(button.text,i)">
                  {{ button.text }}
                </button>
              </div>
            </div>
            <div class="card-body">
              <div>
                <div style="display: block">
                  <canvas baseChart [datasets]="ChartData" [labels]="ChartLabels" [options]="barChartOptions"
                    [colors]="barChartColors" [legend]="barChartLegend" [chartType]="barChartType" style="height: 300px;"
                    (chartHover)="chartHovered($event)" (chartClick)="chartClicked($event)"></canvas>
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset> -->
    </div>
    <div
      [ngClass]="isShowRentalCars && isRentalService == true ? ((isShowContactUsers == true) ? (isMg ? 'das-grid three-two' : 'das-grid four-one') : 'das-grid three-two') : ((isShowContactUsers == true) ? (isMg ? 'das-grid two-three' : 'das-grid three-two') : 'das-grid two-three')">
      <h3 class="titlestyle2 mt30 fontnormal pb-0" translate>
        lblSummary
      </h3>
      <h3 class="titlestyle2 fontnormal mt30" *ngIf="isShowDmsSyncErrors || isShowAfxSyncErrors" translate>
        lblSyncFailure
      </h3>
    </div>
    <div class="das-grid dash-sub-grid mt-1">
      <div class="dashbox  align-items-center lblDealer" (click)="ActiveDealers()"
        *ngIf="isShowDealers && !isDealerLoggedIn && !isMg">
        <div class="row align-items-center ">
          <div class="col pr-0">
            <em class="fa-solid fa-warehouse fas"></em>
          </div>
          <div class="col flex-grow-3 dash-sub-grid-right">
            <h3 translate class="mb10">
              lblActiveDealers
            </h3>
            <h5>
              {{cardCounts.dealerCount}}
            </h5>
          </div>
        </div>
      </div>

      <div class="dashbox  align-items-center lblCustomer" (click)="ActiveUsers()" *ngIf="isShowUsers">
        <div class="row align-items-center ">
          <div class="col pr-0">
            <em class="fa-solid fa-users fas"></em>
          </div>
          <div class="col flex-grow-3 dash-sub-grid-right">
            <h3 translate class="mb10">
              lblActiveUsers
            </h3>
            <h5>
              {{cardCounts.userCount}}
            </h5>
          </div>
        </div>
      </div>

      <div class="dashbox  align-items-center lblRentalVehicle" (click)="ContactUsers()" *ngIf="isShowContactUsers">
        <div class="row align-items-center ">
          <div class="col pr-0">
            <em class="fa-solid fa-phone fas"></em>
          </div>
          <div class="col flex-grow-3 dash-sub-grid-right">
            <h3 translate class="mb10">
              lblContactUsers
            </h3>
            <h5>
              {{cardCounts.contactUserCount}}
            </h5>
          </div>
        </div>
      </div>

      <div class="dashbox  align-items-center lblRentalVehicle" (click)="RentalVehicle()"
        *ngIf="isShowRentalCars && isRentalService">
        <div class="row align-items-center ">
          <div class="col pr-0">
            <em class="fa-solid fa-car fas"></em>
          </div>
          <div class="col flex-grow-3 dash-sub-grid-right">
            <h3 translate class="mb10">
              lblRentalVehicles
            </h3>
            <h5>
              {{cardCounts.rentalVehicleCount}}
            </h5>
          </div>
        </div>
      </div>

      <div class="dashbox  align-items-center lblPlannertoDMS" (click)="SetDMSToPlannerFlag('lblTodayDmsLog')"
        *ngIf="isShowDmsSyncErrors">
        <div class="row align-items-center ">
          <div class="col pr-0">
            <em class="fas icn-fail-planner-to-dms"></em>
          </div>
          <div class="col flex-grow-3 dash-sub-grid-right">
            <h3 translate class="mb10">
              lblPlannertoDMS
            </h3>

            <div class="d-flex align-items-center justify-content-between"
              (click)="SetDMSToPlannerFlag('lblTodayDmsLog')">
              <h5>
                {{SyncCounts?.dmsSyncFailedLogTodayCount}}
              </h5>
              <div class="d-flex align-items-center justify-content-end"
                (click)="SetDMSToPlannerFlag('lblWeeklyDmsLog')">
                <span class="sub-tomorrow-txt" translate>lblWeekly</span><span
                  class="sub-tomorrow-txt mx-2">-</span><span
                  class="sub-tomorrow-count">{{SyncCounts?.dmsSyncFailedLogWeekCount}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="dashbox  align-items-center lblDMStoPlanner" (click)="SetPlannerToDMSFlag('lblTodayDmsLog')"
        *ngIf="isShowAfxSyncErrors">
        <div class="row align-items-center ">
          <div class="col pr-0">
            <em class="fas icn-fail-dms-to-planner"></em>
          </div>
          <div class="col flex-grow-3 dash-sub-grid-right">
            <h3 translate class="mb10">
              lblDMStoPlanner
            </h3>
            <div class="d-flex align-items-center justify-content-between"
              (click)="SetPlannerToDMSFlag('lblTodayDmsLog')">
              <h5>
                {{SyncCounts?.afxSyncFailedLogTodayCount}}
              </h5>
              <div class="d-flex align-items-center justify-content-end"
                (click)="SetPlannerToDMSFlag('lblWeeklyDmsLog')">
                <span class="sub-tomorrow-txt" translate>lblWeekly</span><span
                  class="sub-tomorrow-txt mx-2">-</span><span
                  class="sub-tomorrow-count">{{SyncCounts?.afxSyncFailedLogWeekCount}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- For Exception log Widget-->
      <div class="dashbox  align-items-center exceptionlog" (click)="SetExceptionLogFlag('todaylog')" *ngIf="isShowExceptionLog">
        <div class="row align-items-center ">
          <div class="col pr-0">
            <em class="fas icn-exception-log"></em>
          </div>
          <div class="col flex-grow-3 dash-sub-grid-right">
            <h3 translate class="mb10">
              lblExceptionLog
            </h3>
            <div class="d-flex align-items-center justify-content-between" (click)="SetExceptionLogFlag('todaylog')">
              <h5>
                {{SyncCounts?.exceptionLogTodayCount}}
              </h5>
              <div class="d-flex align-items-center justify-content-end" (click)="SetExceptionLogFlag('weeklog')">
                <span class="sub-tomorrow-txt" translate>lblWeekly</span><span class="sub-tomorrow-txt mx-2">-</span><span
                  class="sub-tomorrow-count">{{SyncCounts?.exceptionLogWeekCount}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="table-card mt30 lblstyle">
      <div class="d-flex sub-card-title-border align-items-center">
        <div class="flex-grow-1">
          <h5 class="titlestyle2 border-none p-20px" translate>lblSource</h5>
        </div>
        <div class="d-flex justify-content-end align-items-center">
          <div class="px-20px">
            <button *ngFor="let button of buttons; let i = index"
              [ngClass]="button.isClicked == true ? 'sorting selected' : 'sorting'"
              (click)="onTimeSelection(button.text,i)">
              {{ button.text }}
            </button>
          </div>
        </div>
      </div>

      <div class="">
        <table class="table table-hover table-borderless table-centered align-middle table-nowrap mb-0">
          <caption></caption>
          <thead class="text-muted bg-soft-light">
            <tr>
              <th>System</th>
              <th *ngFor="let sel of SelectedData; let i = index" class="text-center">{{sel.name}}</th>
              <th class="text-center" translate>lblTotal</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="SmartPlannerFeature">
              <td>
                <div class="d-flex align-items-center">
                  <em class="icn-bg-rounded icn-bg-darkSea">S
                  </em>
                  <h6 class="mb-1 semibold fs-14px ml-3" translate>lblSmartPlanner</h6>
                </div>
              </td>
              <td *ngFor="let sel of SelectedData;let i = index" class="text-center">
                {{sel.plannerCount}}
              </td>
              <td class="text-center">
                {{plannerTotal}}
              </td>
            </tr>
            <tr *ngIf="WidgetFeature">
              <td>
                <div class="d-flex align-items-center">
                  <em class="icn-bg-rounded icn-bg-red">{{ isMg ? 'O' : 'W'}}
                  </em>
                  <h6 class="mb-1 semibold fs-14px ml-3" *ngIf="isMg">OLB</h6>
                  <h6 class="mb-1 semibold fs-14px ml-3" *ngIf="!isMg" translate>lblWidget</h6>
                </div>
              </td>
              <td *ngFor="let sel of SelectedData;let i = index" class="text-center">
                {{sel.widgetCount}}
              </td>
              <td class="text-center">
                {{widgetTotal}}
              </td>
            </tr>
            <tr *ngIf="DMSFeature">
              <td>
                <div class="d-flex align-items-center">
                  <em class="icn-bg-rounded icn-bg-green">D
                  </em>
                  <h6 class="mb-1 semibold fs-14px ml-3" translate>lblDMS</h6>
                </div>
              </td>
              <td *ngFor="let sel of SelectedData;let i = index" class="text-center">
                {{sel.dmsCount}}
              </td>
              <td class="text-center">
                {{dmsTotal}}
              </td>
            </tr>

          </tbody>
        </table>
      </div>

      <div class="table-card mt30 lblstyle"
        *ngIf="CheckInFeature || OrderInvoiceAmountFeature || WorkshopCapacityFeature">
        <div class="d-flex sub-card-title-border align-items-center">
          <div class="flex-grow-1">
            <h5 class="titlestyle2 border-none p-20px" translate>lblAppointmentOtherDetails</h5>
          </div>
        </div>
      </div>
      <div class="" *ngIf="CheckInFeature || OrderInvoiceAmountFeature || WorkshopCapacityFeature">
        <table class="table table-hover table-borderless table-centered align-middle table-nowrap mb-0">
          <caption></caption>
          <thead class="text-muted bg-soft-light">
            <tr>
              <th></th>
              <th *ngFor="let sel of SelectedData; let i = index" class="text-center">{{sel.name}}</th>
              <th class="text-center" translate>lblTotal</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="CheckInFeature">
              <td>
                <div class="d-flex align-items-center">
                  <em class="icn-bg-rounded icn-bg-blue">C
                  </em>
                  <h6 class="mb-1 semibold fs-14px ml-3" translate>lblCheckedIn</h6>
                </div>
              </td>
              <td *ngFor="let sel of SelectedData;let i = index" class="text-center">
                {{sel.checkedInCount}}
              </td>
              <td class="text-center">
                {{checkedInTotal}}
              </td>
            </tr>
            <tr *ngIf="OrderInvoiceAmountFeature">
              <td>
                <div class="d-flex align-items-center">
                  <em class="icn-bg-rounded icn-bg-lightgreen">OV
                  </em>
                  <h6 class="mb-1 semibold fs-14px ml-3" translate>lblOrderValueInvoiceAmount</h6>
                </div>
              </td>
              <td *ngFor="let sel of SelectedData;let i = index" class="text-center">
                {{sel.invoiceAmountSum | number:'1.2-2'}}
              </td>
              <td class="text-center">
                {{invoiceAmountTotal | number:'1.2-2'}}
              </td>
            </tr>
            <tr *ngIf="WorkshopCapacityFeature">
              <td>
                <div class="d-flex align-items-center">
                  <em class="icn-bg-rounded icn-bg-gray">WC
                  </em>
                  <h6 class="mb-1 semibold fs-14px ml-3" translate>lblWorkshopCapacityRow
                    <em class="fa fa-info-circle" ngbTooltip="{{'lblDataCalculatedInHours' | translate}}"
                      tooltipClass="custom-revert"></em>
                  </h6>
                </div>
              </td>
              <td *ngFor="let sel of SelectedData;let i = index" class="text-center">
                {{sel.serviceTime}} / {{sel.plannedTime}} / {{sel.allocatedTime}}
              </td>
              <td class="text-center">
                {{serviceTime}} / {{plannedTime}} / {{allocatedTime}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>